import { render, staticRenderFns } from "./calendar.vue?vue&type=template&id=18bdc1ce&scoped=true&"
import script from "./calendar.vue?vue&type=script&lang=ts&"
export * from "./calendar.vue?vue&type=script&lang=ts&"
import style0 from "./calendar.vue?vue&type=style&index=0&id=18bdc1ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18bdc1ce",
  null
  
)

component.options.__file = "calendar.vue"
export default component.exports